module.exports = __webpack_public_path__ + "img/windzonen_v2.24693f96.svg";